import { ProductStateType } from "@/util/constants";
import styles from "@/elements-react/product-element/product-element.module.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export interface ProductElementStatusPropsFactoryProps {
  state: number;
  isPrimaryType?: boolean;
  originalMpn?: string;
  exchanges?: Array<any>;
}

interface ProductElementStatusProps {
  isDiscontinued?: boolean;
  originalMpn?: string;
}

export const productElementStatusPropsFactory = (props: ProductElementStatusPropsFactoryProps): ProductElementStatusProps => {
  const { state, isPrimaryType, originalMpn, exchanges } = props;
  const hasExchanges = !!exchanges?.length;
  const isDiscontinued = state === ProductStateType.Discontinued && !hasExchanges && isPrimaryType;

  return { isDiscontinued, originalMpn };
};

export const ProductElementStatus = (props: ProductElementStatusProps) => {
  const { isDiscontinued, originalMpn } = props;
  const { t } = useTranslation();

  if (!isDiscontinued && !originalMpn) {
    return null;
  }

  let text;

  if (originalMpn) {
    text = (
      <span className={styles["status-text"]}>
        {t("bk4fnvbncvx31kvc.replacement-for", "Replacement for")} <span className={styles["exchange-mpn"]}>{originalMpn}</span>
      </span>
    );
  } else if (isDiscontinued) {
    text = <span>{t("qwe9ieuj32nmvjib.not-produced", "Not produced")}</span>;
  }

  const className = originalMpn ? "exchange" : "inactive";

  return <div className={classNames(styles.status, styles[className])}>{text}</div>;
};
